module.exports = __webpack_public_path__ + "img/animation-controller.ef354e81.png";